export default "images/parvin-going-home.jpg";